import React, { useEffect, useState } from 'react';
import '../styles/JobPreview.scss'; 
import axios from 'axios';
import DOMPurify from 'dompurify';
interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  careerId?: string;
}

const JobPreview: React.FC<PopupProps> = ({ isOpen, onClose, careerId }) => {
    const Arrow = `${process.env.REACT_APP_S3_URL}RIghtArrowBgWhite.svg`;

  const [title, setTitle] = useState('');
  const [profileSummary, setProfileSummary] = useState('');
  const [requirements, setRequirements] = useState('');

  async function getJobDetails() {
    await axios.get(process.env.REACT_APP_BACKEND_URL + `/api/v1/careers/${careerId}`)
        .then((response: any) => {
            console.log(response.data);
            setTitle(response.data?.position);
            setProfileSummary(response.data?.profileSummary);
            setRequirements(response.data?.body);
        })
        .catch((error: any) => {
            console.error('Error fetching jobs:', error);
        });
  }
  useEffect(() => {
    getJobDetails()
  }, [careerId]);

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className='flexRow alignBetween'>
            <h2>{title}</h2>
            <div >
                <button onClick={onClose} className='closeButton'>Close</button>
                <a href="mailto:careers@mobilewaretech.com?subject=Job%20Application&body=I%20am%20interested%20in%20applying%20for%20the%20position." >
                    <button className="cta-button">
                        <div className='align-proper'>
                            <span className='button-name'>
                            Apply Now &nbsp;&nbsp;
                            </span>
                            <img className='arrow-icon' src={Arrow} alt='' />
                        </div>
                    </button>
                </a>
            </div>
        </div>
        <div className="popup-scrollable-content">
            <div className='contentCard'>
                <div className='contentHeader'>
                    <h3>Profile Summary:</h3>
                </div>
                <div className='contentDescription'>
                    <div
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(profileSummary || '') }}
                    />
                    {/* <p>A software engineer follows standard operating procedures to break down problems and develop solutions through flowcharts and algorithms. They use their expertise in programming languages to write organised code to assemble the necessary software and oversee the deployment of the software. They also build software components from time to time and integrate them into the organisation’s existing software system. While supervising the software development cycle, they figure out the feasibility of various projects and create verification plans. They additionally work in the teams of software engineers and collaborate with other engineers to come up with the best software solution possible</p> */}
                </div>
            </div>
            <div className='contentCard'>
                <div className='contentHeader'>
                    <h3>General Requirements:</h3>
                </div>
                <div className='contentDescription'>
                    <div
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(requirements || '') }}
                    />
                    {/* <p>A software engineer follows standard operating procedures to break down problems and develop solutions through flowcharts and algorithms. They use their expertise in programming languages to write organised code to assemble the necessary software and oversee the deployment of the software. They also build software components from time to time and integrate them into the organisation’s existing software system. While supervising the software development cycle, they figure out the feasibility of various projects and create verification plans. They additionally work in the teams of software engineers and collaborate with other engineers to come up with the best software solution possible</p> */}
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default JobPreview;
